export default "__VITE_ASSET__BAeylww9__"